import { GuideLineEnum } from '@/helpers/enums/guide-line.enum';

const useGuideLineComposable = () => {
  const localStorageGuideLine = JSON.parse(
    localStorage.getItem('guide-line') || 'null'
  );

  const isGuideLocaleStorage = (value: string) => {
    if (localStorageGuideLine) {
      if (value in localStorageGuideLine) {
        return localStorageGuideLine[value];
      } else {
        localStorageGuideLine[value] = true;
        localStorage.setItem(
          'guide-line',
          JSON.stringify(localStorageGuideLine)
        );
        return localStorageGuideLine[value];
      }
    } else {
      const newGuideLineObject = {} as { [key: string]: boolean };
      for (const value in GuideLineEnum) {
        const key = GuideLineEnum[value as keyof typeof GuideLineEnum];
        newGuideLineObject[key] = true;
      }
      localStorage.setItem('guide-line', JSON.stringify(newGuideLineObject));
      return newGuideLineObject[value];
    }
  };
  const noShowAgain = (value: string) => {
    localStorageGuideLine[value] = false;
    localStorage.setItem('guide-line', JSON.stringify(localStorageGuideLine));
  };

  return {
    isGuideLocaleStorage,
    noShowAgain,
  };
};

export default useGuideLineComposable;
